import { mauticApi, apiService } from "@/lib/api"
import { authLogger } from "@/lib/logger"
import { Routes } from "@/lib/routes"
import { SignupFormData } from "@/types/auth/"

const instance = apiService

export async function sendUserDataToMautic({ data }: { data: SignupFormData }) {
   if (typeof window === "undefined") return null
   try {
      const fields: Record<string, string | undefined> = {
         email: data.email,
         first_name: data.firstName,
         last_name: data.lastName,
         firstname: data.firstName,
         lastname: data.lastName,
         phone: data.phone,
         company_name: data.company,
         company: data.company,
         city: data.city,
         state: data.state,
         title: data.position,
         which_best_describes_your: data.companyOperations,
         what_best_describes_your: data.companyDescription,
         website: data.website,
      }

      const params = new URLSearchParams()
      for (const [key, value] of Object.entries(fields)) {
         if (value) params.append(`mauticform[${key}]`, String(value))
      }
      const formId = process.env.NEXT_PUBLIC_NODE_ENV === "development" ? "7" : "6"
      params.append("mauticform[formId]", formId) // using form name as identifier since we're not using the form submit endpoint
      params.append("mauticform[return]", window.location.href)

      const res = await mauticApi.post(`/form/submit/ajax?formId=${formId}`, params, {
         headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded",
         },
      })
      return res
   } catch (error) {
      authLogger.warn(
         { error: error instanceof Error ? error.message : error },
         "sendUserDataToMautic failed (non-blocking)",
      )
      return null
   }
}

export async function resetRAPassword({ reset_token, password }: { reset_token: string; password: string }) {
   try {
      const response = await instance.post(Routes.api.authResetPassword.getPath(), {
         reset_token: reset_token,
         password: password,
      })
      authLogger.debug({}, "Password reset successful")
      return response
   } catch (error) {
      authLogger.error({ error: error instanceof Error ? error.message : error }, "Password reset failed")
      throw error
   }
}
export async function sendResetPasswordEmail(email: string) {
   try {
      const response = await instance.post(Routes.api.authSendPasswordResetEmail.getPath(), {
         email,
      })
      return response
   } catch (error) {
      authLogger.error({ error: error instanceof Error ? error.message : error }, "Send password reset email failed")
      throw error
   }
}
